export const VAULTS_V3_MENU = [
  { path: '/v3', label: 'v3 Vaults' },
  { path: 'https://docs.yearn.fi/getting-started/products/yvaults/v3', label: 'Docs' },
  { path: 'https://discord.gg/yearn', label: 'Support', target: '_blank' },
  { path: 'https://blog.yearn.fi/', label: 'Blog', target: '_blank' },
  {
    path: 'https://gov.yearn.fi/',
    label: 'Discourse',
    target: '_blank'
  }
]
